import { render, staticRenderFns } from "./OptionsTypeAnswer.vue?vue&type=template&id=0db84dd7&scoped=true&"
import script from "./OptionsTypeAnswer.vue?vue&type=script&lang=js&"
export * from "./OptionsTypeAnswer.vue?vue&type=script&lang=js&"
import style0 from "./OptionsTypeAnswer.vue?vue&type=style&index=0&id=0db84dd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db84dd7",
  null
  
)

export default component.exports